import React from 'react';
import {Text} from '@/ui-kits';

interface PhotoGuidelinesTooltipProps {
  show: boolean;
}

const guidelines = [
  'Half-body waist-up',
  'Professional attire (lab coat)',
  'Plain or blue background',
  'JPG/PNG up to 5 MB',
];

export const PhotoGuidelinesTooltip: React.FC<PhotoGuidelinesTooltipProps> = ({show}) => {
  if (!show) return null;

  return (
    <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 md:left-full md:translate-x-0 md:top-0 md:ml-2 z-50 w-64 bg-white rounded-lg shadow-lg border border-ui_input_border p-2">
      <Text variant="body" className="!text-deep_blue !font-FigtreeBold mb-1 !text-2xl">
        Guidelines:
      </Text>
      <ul className="space-y-0.5 list-disc pl-5">
        {guidelines.map((guideline, index) => (
          <li key={index}>
            <Text variant="body" className="text-deep_blue !font-FigtreeRegular text-xs leading-tight inline">
              {guideline}
            </Text>
          </li>
        ))}
      </ul>
      {/* Arrow pointing up on mobile, left on desktop */}
      <div className="absolute left-1/2 -translate-x-1/2 -top-2 md:hidden w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-b-white border-r-transparent" />
      <div className="absolute left-1/2 -translate-x-1/2 -top-2.5 md:hidden w-0 h-0 border-l-[5px] border-r-[5px] border-b-[5px] border-l-transparent border-b-ui_input_border border-r-transparent" />
      {/* Arrow pointing left on desktop */}
      <div className="hidden md:block absolute right-full top-3 w-0 h-0 border-t-4 border-b-4 border-r-4 border-t-transparent border-r-white border-b-transparent" />
      <div className="hidden md:block absolute right-full top-3 -mr-[1px] w-0 h-0 border-t-[5px] border-b-[5px] border-r-[5px] border-t-transparent border-r-ui_input_border border-b-transparent" />
    </div>
  );
};

